module.exports = __webpack_public_path__ + "static/media/submitIcon.e4b436e2.svg";